import React, { useMemo } from 'react';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';

const EllipsisBox = ({ content, minWidth, lineClamp }: any) => {
    const [isOverflow, setIsOverflow] = React.useState(false);

    const measureRef = React.useRef<HTMLSpanElement>(null);

    React.useEffect(() => {
        if (measureRef.current) {
            setIsOverflow(measureRef.current.scrollWidth > minWidth);
        }
    }, [content, minWidth]);

    const styles = useMemo(() => {
        if (!isOverflow) return {};
        return {
            display: '-webkit-box',
            whiteSpace: 'normal',
            wordBreak: 'break-all',
            WebkitLineClamp: lineClamp,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: minWidth
        };
    }, [isOverflow, minWidth, lineClamp]);

    const contentBox = (
        <Box
            ref={measureRef}
            sx={styles}
        >
            {content}
        </Box>
    );

    return isOverflow ? (
        <Tooltip title={content}>
            {contentBox}
        </Tooltip>
    ) : (
        contentBox
    );
};

export default EllipsisBox;
